export default "__VITE_ASSET__Dv8Mm6if__"